import { useEffect } from "react";

/**
 * Sets <title> and <meta name="description"> for the current page.
 * Restores nothing on unmount — the next page sets its own values.
 */
export default function useDocumentMeta({ title, description } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
